import React, { PropTypes, Component } from 'react';
import partial from 'lodash/partial';
import { shareLink } from 'common/utils';
import CopyLinkButton from 'common/components/copy_link_button';
import DropdownMenu from 'common/components/dropdown_menu';

/**
 * Header dropdown menu.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class HeaderMenu extends Component {
  constructor(props) {
    super(props);

    this.share = this.share.bind(this);
    this.getProfileLink = this.getProfileLink.bind(this);
  }

  getProfileLink() {
    const { profileUsername } = this.props;
    /* handle missing window obj when server-rendering */
    if (typeof window !== 'undefined') {
      return `${window.location.origin}/users/${profileUsername}`;
    }
    return '';
  }

  share(socialNetwork) {
    shareLink(this.getProfileLink(), socialNetwork);
  }

  render() {
    const buttons = [{
      label: <CopyLinkButton link={this.getProfileLink()}/>,
      action: () => {}, // action is performed within <CopyLinkButton/>
      show: true,
      closeOnClick: false
    },{
      label: <span><i className="fa fa-fw fa-facebook" /> Share on Facebook</span>,
      action: partial(this.share, 'facebook'),
      show: true
    }, {
      label: <span><i className="fa fa-fw fa-twitter" /> Tweet</span>,
      action: partial(this.share, 'twitter'),
      show: true
    }];

    return <DropdownMenu buttons={buttons} className="button-wrapper right"/>;
  }
}

/**
 * PropTypes.
 *
 * @property {string} profileUsername - profile username
 */
HeaderMenu.propTypes = {
  profileUsername: PropTypes.string,
};
